import React from "react";
import ReactDOM from "react-dom/client";
import { suppressZoomWhiteboardNoise } from "./utils/suppressZoomWhiteboardNoise";
import { App } from "./App";

import './App.css';

suppressZoomWhiteboardNoise();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
);